import styled from 'styled-components'
import { WHITE } from '../../../screens/DesignerTool/constants'

interface StyledProps {
  isMobile?: boolean
  selected?: boolean
}

export const ToolBarContainer = styled.div`
  width: 100%;
  height: 62px;
  display: flex;
  padding: 5px 22px;
  background-color: black;
  animation: fade-in-top-toolbar 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top-toolbar {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 1440px) {
    padding: 5px 10px;
  }
`

export const ToolItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
`

export const ToolItemIcon = styled.img`
  width: 22px;
  padding-bottom: 3px;
`

export const ToolItemName = styled.div`
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
  font-weight: 400; 
  color: #8c8c8c;
`

export const ToolListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 25%;
`

export const Variants = styled.div`
  display: flex;
  margin-right: 10px;
  align-items: center;

  @media (max-width: 1440px) {
    margin-right: 0;
  }
`

export const VariantButton = styled.img`
  width: 47px;
  object-fit: contain;
  max-height: 46px;
  border: 1px solid ${({ selected }: StyledProps) => (selected ? '#ac6457' : '#5c5c5c')};
  border-radius: 3px;
  transition: all 0.25s;
  padding: 5px;
  background: ${({ selected }: StyledProps) => (selected ? '#bebebe' : WHITE)};
  filter: invert(100%);
  cursor: pointer;
  margin-right: 10px;

  &:hover {
    filter: none;
  }
`

export const Variant = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.25s;
  border-radius: 3px;
  margin-right: 30px;

  &:hover {
    background: #474747;
    cursor: pointer;
  }
`

export const VariantIcon = styled.img`
  width: 32px;
  object-fit: contain;
  max-height: 50px;
  padding: 5px;
  cursor: pointer;
  
`

export const VariantName = styled.p`
  font-size: 12px;
  color: ${WHITE};
  margin: 0;
  padding: 0 5px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/ToolBar/styledComponents.tsx